import React from 'react';
import { useEffect } from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import { getMatchIdOrStageId } from '../../data/utils';
import { WidgetContext } from '../../data/widgets/WidgetContext';
import LiveSuiteCompetition from '../../live/live-suite/LiveSuiteCompetition';
import { useUISettings } from '../../UISettingsProvider';
import PrematchHomeCompetition from './PrematchHomeCompetition';
import PrematchHomeCompetitionMacrogruppo from './PrematchHomeCompetitionMacrogruppo';
import BetBuilderMatchContainer from './BetBuilderMatchContainer';
import { systemCode } from '../..';

export default function PrematchHomeMatch(props) {
    const uiSettings = useUISettings();
    const widgetContext = React.useContext(WidgetContext);
    const match = props.match;

    useEffect(function() {
        const settings = {
            widgetS5Layout: '#3'
        };
        if (props.isLive) {
            Object.assign(settings, {
                widgetStartCollapsed: true,
                widgetContainerId: null, //imposto container null, il container lo decide il component che visualizza il match
                widgetMatchId: getMatchIdOrStageId(match)
            });
        }
        widgetContext.setWidget(settings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match]);

    const show = !uiSettings.fullScreen && match != null;

    if (!show) {
        return null;
    }

    return (
        <div id="secondo-blocco-sport" className={"sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow"}>
            <GoUpBtn />
            {
            	match.betBuilder?
            	<BetBuilderMatchContainer betBuilderMatch={match} />
            	:
            	<>
            	{props.isLive ?
	                <LiveSuiteCompetition match={match} />
	                :
	                <>
	                    {match.macrogruppi.length > 1 ?
	                    (systemCode === 'STARCASINO' ?  <PrematchHomeCompetition match={match} /> : <PrematchHomeCompetitionMacrogruppo match={match} macrogruppi={match.macrogruppi} /> )    
	                        :
	                        <PrematchHomeCompetition match={match} />
	                    }
	                </>
            	}
            	</>
            }

        </div>
    );
}
